import { Fragment, useRef } from 'react';
import { DialogTitle, Description } from '@headlessui/react';
import { Dialog, Transition } from '@headlessui/react';

type CustomConfirmModalProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  data: {
    title?: string;
    message?: string;
    onClick: () => void;
  };
};

const CustomConfirmModal: React.FC<CustomConfirmModalProps> = ({
  show,
  setShow,
  data
}) => {
  const initialFocusRef = useRef<HTMLButtonElement>(null);
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog
        as='div'
        className='relative z-50'
        onClose={() => setShow(false)}
        initialFocus={initialFocusRef}
      >
        <Transition.Child as={Fragment}>
          <div className='fixed inset-0 bg-black bg-opacity-50' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex w-full min-h-full items-center justify-center p-4'>
            <div className='relative'>
              <Transition.Child as={Fragment}>
                <Dialog.Panel className='relative w-full mx-auto rounded-lg bg-white shadow-xl max-w-sm'>
                  <div className='flex justify-end p-2'>
                    <button
                      type='button'
                      ref={initialFocusRef}
                      onClick={() => setShow(false)}
                      className='rounded-md text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500'
                      aria-label='Close modal'
                    >
                      <svg
                        className='h-6 w-6'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='currentColor'
                        aria-hidden='true'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth={2}
                          d='M6 18L18 6M6 6l12 12'
                        />
                      </svg>
                    </button>
                  </div>
                  <div className='flex flex-col items-center gap-4 p-4 md:p-6 text-center'>
                    {data?.title && (
                      <DialogTitle
                        as='h2'
                        className='text-lg font-bold text-gray-900 mb-0'
                      >
                        {data.title}
                      </DialogTitle>
                    )}
                    {data?.message && (
                      <Description className='text-sm text-gray-600 mb-4'>
                        {data.message}
                      </Description>
                    )}
                    <div className='flex gap-3 md:gap-4 justify-center pt-2 md:pt-4'>
                      <button
                        type='button'
                        className='px-4 py-2 bg-transparent border border-gray-300 text-slate-700 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500'
                        onClick={() => {
                          setShow(false);
                        }}
                      >
                        No
                      </button>
                      <button
                        type='button'
                        className='px-4 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500'
                        onClick={() => {
                          data?.onClick();
                        }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CustomConfirmModal;
